/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { tagsEndPoints } from 'api/tags/constants';
import {
  TTagsCreateBE,
  TTagsCreateBody,
  TTagsDeleteBE,
  TTagsGetListBE,
  TTagsGetListQueryParams,
  TTagsToggleActiveBE,
  TTagsUpdateBE,
  TTagsUpdateBody,
} from 'api/tags/tags.types';
import createHttpClient from 'store/httpClient';
import { fromObjectToQueryString } from 'utils/api';

export const getTagsListAsyncThunk = createAsyncThunk<
  TTagsGetListBE['data'],
  { queryParams: TTagsGetListQueryParams } | void
>('tags/getList', async (args, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.get<TTagsGetListBE>(
      tagsEndPoints.getList(
        fromObjectToQueryString(
          typeof args === 'object' ? args?.queryParams : {}
        )
      )
    );

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

// ---------------- CREATE ----------------

export const createTagAsyncThunk = createAsyncThunk<
  TTagsCreateBE['data'],
  { body: TTagsCreateBody; onSuccess?: () => void }
>('tags/create', async ({ body, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);
    const response = await httpClient.post<TTagsCreateBE, TTagsCreateBody>(
      tagsEndPoints.create(),
      body
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

// ---------------- UPDATE ----------------

export const updateTagAsyncThunk = createAsyncThunk<
  TTagsUpdateBE['data'],
  { id: string; body: TTagsUpdateBody; onSuccess?: () => void }
>('tags/update', async ({ id, body, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);
    const response = await httpClient.put<TTagsUpdateBE, TTagsUpdateBody>(
      tagsEndPoints.update(id),
      body
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

// ---------------- DELETE ----------------

export const deleteTagAsyncThunk = createAsyncThunk<
  TTagsDeleteBE['data'],
  { id: string; onSuccess?: () => void }
>('tags/delete', async ({ id, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.patch<TTagsDeleteBE>(
      tagsEndPoints.delete(id)
    );

    if (onSuccess) {
      onSuccess();
    }
    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});

export const toggleTagActiveAsyncThunk = createAsyncThunk<
  TTagsToggleActiveBE['data'],
  { id: string; onSuccess?: () => void }
>('tags/toggleActive', async ({ id, onSuccess }, { rejectWithValue }) => {
  try {
    const httpClient = createHttpClient(undefined);

    const response = await httpClient.patch<TTagsToggleActiveBE>(
      tagsEndPoints.toggleActive(id)
    );

    if (onSuccess) {
      onSuccess();
    }

    return response.data;
  } catch (_) {
    return rejectWithValue(null);
  }
});
